import { action } from 'typesafe-actions'
import { ModalActions, ModalState } from '../types'

export const setModalState = (state: ModalState) =>
  action(ModalActions.SET_MODAL_STATE, state)

export const clearModalState = () => action(ModalActions.CLEAR_MODAL_STATE)
